var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', [_vm._v("Styles")]), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('h2', [_vm._v("Topline")]), _c('p', [_c('u', [_vm._v("u-lnb-topline")])]), _c('br'), _c('div', {
    staticClass: "mw-200px"
  }, [_c('u-lnb-topline', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('h2', [_vm._v("Topline Border")]), _c('p', [_c('u', [_vm._v("u-lnb-topline-border")])]), _c('br'), _c('div', {
    staticClass: "mw-200px"
  }, [_c('u-lnb-topline-border', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('h2', [_vm._v("All Filled")]), _c('p', [_c('u', [_vm._v("u-lnb-all-filled")])]), _c('br'), _c('div', {
    staticClass: "mw-200px"
  }, [_c('u-lnb-all-filled', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('h2', [_vm._v("All Opacity Black")]), _c('p', [_c('u', [_vm._v("u-lnb-all-opacity-black")])]), _c('br'), _c('div', {
    staticClass: "mw-200px grey"
  }, [_c('u-lnb-all-opacity-black', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "3"
    }
  }, [_c('h2', [_vm._v("All Border")]), _c('p', [_c('u', [_vm._v("u-lnb-all-border")])]), _c('br'), _c('div', {
    staticClass: "mw-200px"
  }, [_c('u-lnb-all-border', [_c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])]), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("lnb")])])])], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }